module.exports = __webpack_public_path__ + "static/img/logo_ddc_white.d3bd7508.svg";